






























import {
  Component, Vue, PropSync, Prop, Watch,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class ConfigurationDelete extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('configurationValue', {}) configSync!: any;

  @Prop({}) documentHeadline!: string;

  @Prop({}) label!: string;

  @Prop({}) loading!: boolean;

  public close() {
    this.$emit('cancel');
  }

  public onDelete() {
    this.$emit('delete', this.configSync);
  }
}
